import React from 'react'

import { Card, Flex, Icon, Skeleton, Text } from '@driftt/dds'
import { faCalendar } from '@driftt/dds.icons/regular/faCalendar'
import { faComment } from '@driftt/dds.icons/regular/faComment'
import { faCrown } from '@driftt/dds.icons/regular/faCrown'
import { faEnvelope } from '@driftt/dds.icons/regular/faEnvelope'
import { TypeFormats } from '@driftt/dds.reports'

import { ChatBubble, StyledCardEvent } from './TimelineEvent.styled'
import {
  TimelineEventCardProps,
  TimelineEventProps,
} from './TimelineEvent.types'

export const DeprecatedTimelineEventTemplate = ({
  header = '',
  date = '',
  children,
  headerLeftElement = null,
  headerRightElement = null,
  isLoading = false,
}: TimelineEventProps) => {
  return (
    <Flex direction="column" fullWidth>
      <Skeleton isLoading={isLoading} height={20} width={150}>
        <Text variant="body">
          {TypeFormats.SIMPLE_DATE_TIME(new Date(date))}
        </Text>
      </Skeleton>
      <Skeleton isLoading={isLoading} height={80}>
        <StyledCardEvent width="100%">
          <Card.Content
            as={Flex}
            gap={2}
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Flex justifyContent="flex-start" fullHeight>
              {headerLeftElement}
            </Flex>
            <Flex direction="column" fullHeight fullWidth>
              {header}
              {children}
            </Flex>
            <Flex justifyContent="flex-start" fullHeight>
              {headerRightElement}
            </Flex>
          </Card.Content>
        </StyledCardEvent>
      </Skeleton>
    </Flex>
  )
}

const EventIcon = {
  lifecycle: faCrown,
  meeting: faCalendar,
  conversation: faComment,
  emailCaptured: faEnvelope,
}

const TimelineEventCardRoot = ({
  eventType,
  children,
  date = '',
  statusBadge = null,
  isLoading = false,
}: TimelineEventCardProps) => {
  return (
    <Flex direction="column" fullWidth>
      <Flex direction="row" justifyContent="space-between" fullWidth>
        <Skeleton isLoading={isLoading} height={20} width={150}>
          <Text variant="body">{TypeFormats.TIME(new Date(date))}</Text>
        </Skeleton>
        <Skeleton isLoading={isLoading} height={20} width={150}>
          {statusBadge}
        </Skeleton>
      </Flex>
      <Skeleton isLoading={isLoading} height={80}>
        <StyledCardEvent elevation={3}>
          <ChatBubble event={eventType}>
            <Icon icon={EventIcon[eventType]} />
          </ChatBubble>
          {children}
        </StyledCardEvent>
      </Skeleton>
    </Flex>
  )
}

const TimelineEventCard = ({ children }) => {
  return (
    <Card.Content
      as={Flex}
      gap={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      {children}
    </Card.Content>
  )
}

const TimelineEventContent = ({ children }) => {
  return (
    <Flex direction="column" fullHeight fullWidth gap={2}>
      {children}
    </Flex>
  )
}

const TimelineEventCardContentLeft = ({ children: headerLeftElement }) => {
  return (
    <Flex justifyContent="flex-start" alignItems="center" fullHeight>
      {headerLeftElement}
    </Flex>
  )
}

const TimelineEventCardContentRight = ({ children: headerRightElement }) => {
  return (
    <Flex justifyContent="flex-start" fullHeight>
      {headerRightElement}
    </Flex>
  )
}

export const TimelineEvent = {
  Root: TimelineEventCardRoot,
  Card: TimelineEventCard,
  Content: TimelineEventContent,
  Right: TimelineEventCardContentRight,
  Left: TimelineEventCardContentLeft,
}
